import { useEffect, useState } from "react";
import { Card, Table, Typography, Divider, Button } from "antd";
import { ArrowLeftOutlined, PrinterOutlined } from "@ant-design/icons";
import { useNavigate, useParams } from "react-router-dom";
import { getTranferRecordWithDetailsApi } from "../../../apiservice/inventory";
import { convertNumberToWords, formatToCompanyTimezone, numberFormat } from "../../../lib/functions";
import PrintWrapper from "../../../components/common/PrintWrapper";

const { Title, Text } = Typography;

const QuickTransferVoucher = ({authInfo}) => {
  const { id } = useParams();
  const [voucher, setVoucher] = useState(null);
  const currency = authInfo?.currency;
  const navigate = useNavigate();

  useEffect(() => {
    if (!id) return;
    getTranferRecordWithDetailsApi({ t_id: id, from: "voucher" }).then((res) => {
      if (res?.data?.length) {
        const data = res.data[0];
        data.details = data.details.map((item) => ({
          ...item,
          qty_display:
            item?.item_qty +
            " " +
            item?.unit_symbol +
            (item?.conversion > 1
              ? ", " + item?.retail_qty + " " + item?.base_unit_name
              : ""),
              per_unit: item?.per_unit_symbol || item?.unit_symbol,
        }));
        setVoucher(data);
      }
    });
  }, [id]);

  if (!voucher) return <Text>Voucher Not Found</Text>;

  const columns = [
    { title: "No.", render: (_, __, i) => i + 1, width: 50 },
    { title: "Item Name", dataIndex: "item_name" },
    { title: "Rate", dataIndex: "item_rate", align: "right", render: (v) => numberFormat(v) },
    { title: "Per", dataIndex: "per_unit", align: "center" },
    { title: "QTY", dataIndex: "qty_display", align: "center" },
    { title: "Total", dataIndex: "item_total", align: "right", render: (v) => numberFormat(v) },
  ];

  return (
    <PrintWrapper title=" -">        
        {/* ✅ Back Button */}
        <div
            style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            marginBottom: 12,
            }}
        >
            {/* Back Button */}
            <Button
            type="default"
            icon={<ArrowLeftOutlined />}
            onClick={() => navigate(-1)}
            >
            Back
            </Button>

            {/* Center Title */}
            <div style={{ flex: 1, textAlign: "center", marginRight: 40 }}>
            <Typography.Title level={4} style={{ margin: 0 }}>
                TRANSFER VOUCHER
            </Typography.Title>
            </div>

            {/* Empty placeholder to balance layout (print stays independent) */}
            <div style={{ width: 85 }}></div>
        </div>
      <Card>
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <div>
            <Text strong>Voucher No:</Text> {voucher.t_voucher_no}<br />
            <Text strong>Date:</Text> {formatToCompanyTimezone(voucher.created_date)?.split[0]}<br />
            <Text strong>Transfer By:</Text> {voucher.full_name}
          </div>
          <div>
            <Text strong>Branch:</Text> {voucher.to_branch_name}<br />
            <Text strong>Branch Address:</Text> {voucher.branch_address}
          </div>
        </div>

        <Divider style={{ margin: "10px 0" }} />

        <Table
          size="small"
          bordered
          pagination={false}
          columns={columns}
          dataSource={voucher.details}
          rowKey="item_id"
        />

        <Divider style={{ margin: "10px 0" }} />

        <div style={{ textAlign: "right", fontWeight: 600 }}>
          <div>Sub Total: {numberFormat(voucher.sub_total)}</div>
          <div>Service Charge: {numberFormat(voucher.total_transport_cost)}</div>
          <div>Grand Total: {currency || "AED"} {numberFormat(voucher.total_amount)}</div>
        </div>

        <Divider style={{ margin: "10px 0" }} />

        <Text>
        <i>
            In Words: {convertNumberToWords(voucher.total_amount, currency)}
        </i>
        </Text>
        <br />
        <Text>
          <b>Description:</b> {voucher.narration || "-"}
        </Text>
      </Card>
    </PrintWrapper>
  );
};

export default QuickTransferVoucher;
